import React from "react";

import ModalAddUserHeader from "../header/header";
import ModalAddUserCompanyUsers from "../company-users/company-users";
import ModalAddUserNewUser from "../new-user/new-user";
import ModalAddUserSubmit from "../submit/submit";

import Classes from "classnames";

export default function ModalAddUserProjectUsersForm(props) {

    const stopPropagation = (e) => {
        e.stopPropagation();
        e.preventDefault();
    }

    const search = props.search ? props.search.trim().toLowerCase() : false;

    let companyUsers = [];
    // only regular users and company managers can see company users
    if (gd.ac.check.company.canSeeCompanyUsers()) {
        if (search) {
            props.companyUsers.map(cu=>{
                if (cu.user.name.toLowerCase().includes(search) === true) companyUsers.push(cu);
            });
        } else {
            companyUsers = props.companyUsers;
        }
    }

    if (!companyUsers || companyUsers.length<1) companyUsers = false;

    const mainClasses = Classes('main','multiselect');

    const modalClasses = Classes('v4-container', 'placement-middle','multiselect');

    return (
        <div className={modalClasses} onClick={stopPropagation}>

            <ModalAddUserHeader search={props.search}
                                onSearchChange={props.onSearchChange}
                                onSearchCancel={props.onSearchCancel}
                                closeModal={props.closeModal}/>

            <div className={mainClasses}>

                <div className="group-name m-b-20">Company users</div>

                <ModalAddUserCompanyUsers companyUsers={companyUsers}
                                          selected={props.selected}
                                          multiselect={props.multiselect}
                                          mode={props.mode}
                                          showDepartments={props.showDepartments}
                                          projectId={props.projectId}
                                          onAccessSelect={props.onAccessSelect}
                                          onUserClick={props.onUserClick}/>

                <ModalAddUserNewUser />

                {!companyUsers && <div className="not-found">No users found</div>}

            </div>

            <ModalAddUserSubmit mode={props.mode}
                                multiselect={props.multiselect}
                                canSubmit={props.canSubmit}
                                onClickSubmit={props.onClickSubmit}/>
        </div>
    );
}